import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomerByEmail } from '../data/models';

@Component({
    selector: 'app-cart-customer',
    template: `
    <form [formGroup]="form" (submit)="addNote()">
      <div class="modal-header">
        <h4 class="modal-title" i18n>Beleg per E-Mail</h4>
        <button type="button" class="btn-close" aria-label="Close" i18n-aria-label
                (click)="activeModal.close()"></button>
      </div>
      <div class="modal-body px-lg-4">
        <div i18n>
          Mit der Angabe Ihrer E-Mail Adresse stimmen Sie dem Erhalt eines elektronischen Beleges zu.
        </div>
        <div class="my-3 d-flex align-items-start flex-column">
          <label class="pb-2" i18n>E-Mail</label>
          <input type="text" ngbAutofocus class="form-control" [formControl]="emailControl">
        </div>

        <div>
          Wenn Sie zusätzlich unseren Newsletter erhalten wollen, können Sie diesem hier zustimmen.
        </div>

        <div class="d-flex justify-content-center">
          <div class="btn-group btn-group-lg py-3" role="group">
            <input type="radio" class="btn-check" id="accept-newsletter" [formControl]="acceptsNewsletterControl"
                   autocomplete="off" [value]="false">
            <label class="btn btn-outline-info" for="accept-newsletter">Ablehnen</label>

            <input type="radio" class="btn-check" id="decline-newsletter" [formControl]="acceptsNewsletterControl"
                   autocomplete="off" [value]="true">
            <label class="btn btn-outline-info" for="decline-newsletter">Zustimmen</label>
          </div>
        </div>
      </div>
      <div
        class="modal-footer justify-content-center align-items-center justify-content-md-between flex-column-reverse flex-md-row p-3 p-md-4">
        <button type="button" class="btn btn-lg btn-danger w-100 w-md-auto mb-3 mb-md-0"
                (click)="removeCustomerFromCart()" i18n [disabled]="loading" [appLoadingOverlay]="loading">Löschen
        </button>
        <button type="submit" class="btn btn-lg btn-info w-100 w-md-auto" i18n
                [disabled]="loading || form.invalid" [appLoadingOverlay]="loading">Bestätigen
        </button>
      </div>
    </form>
  `,
    standalone: false
})
export class CustomerModalComponent {
  @Input() isReturn: boolean = false;
  emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  acceptsNewsletterControl = new UntypedFormControl(false, [Validators.required]);

  form = new UntypedFormGroup({
    email: this.emailControl,
    acceptsNewsletter: this.acceptsNewsletterControl
  });
  loading = false;

  constructor(public activeModal: NgbActiveModal,
              private readonly dataService: DataService) {

    this.emailControl.setValue(dataService.cart?.customer?.email || '');
    this.acceptsNewsletterControl.setValue(dataService.cart?.customer?.acceptsNewsletter || false);
  }

  async addNote() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;

    try {
      await this.updateCustomerData({
        email: this.emailControl.value,
        acceptsNewsletter: this.acceptsNewsletterControl.value
      });
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }

  async removeCustomerFromCart() {
    this.loading = true;
    try {
      await this.updateCustomerData(null);
      this.activeModal.close();
    } finally {
      this.loading = false;
    }
  }

  async updateCustomerData(customer: CustomerByEmail | null) {
    const action = this.isReturn ? 'updatePOSCustomer' : 'updateCartCustomer';

    await this.dataService[action](customer);
  }
}
